import { Box, Skeleton, useTheme } from "@mui/material";
import React from "react";

const WhatsappSkeleton = () => {
    const theme = useTheme();
    return <>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => {
            const isSender = i % 2 === 0;
            return (
                <Box
                    key={i}
                    sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: isSender ? 'flex-end' : 'flex-start',
                        mb: '0.75rem',
                    }}
                >
                    <Skeleton
                        variant="rounded"
                        height={40}
                        width={`${40 + (i % 3) * 20}%`}
                        sx={{
                            borderRadius: '1rem',
                            bgcolor: isSender ? theme.palette.grey[300] : theme.palette.grey[200],
                        }}
                    />
                </Box>
            );
        })}
    </>
}

export default WhatsappSkeleton;